define( [
	"../../core",
	"../../selector"
], function( jQuery ) {
	"use strict";

	return jQuery.expr.match.needsContext;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/traversing/var/rneedsContext.js
// module id = 1VmT
// module chunks = 0 1